import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgArrayPipesModule, NgStringPipesModule } from 'ngx-pipes';

export interface libDataTableColumnInterface {
  property: string;
  label: string;
  sortable?: boolean;
  cellTemplate?: TemplateRef<any>;
}

@Component({
    selector: 'lib-data-table',
    imports: [CommonModule, NgArrayPipesModule, NgStringPipesModule],
    templateUrl: './data-table.component.html',
    styleUrl: './data-table.component.scss'
})
export class LibDataTableComponent implements OnInit, OnChanges {
  @Input() withPaging = false;
  @Input() pagingNbItemsPerPage = 1000;
  @Input() defaultOrderProperty = 'id';
  @Input() trackProperty = 'id';
  @Input() openConditionProperty?: string;
  @Input() withActionColumn = false;
  @Input() listData: any[] = [];
  @Input() withActionOpen = true;
  @Input() columnDefinitions: libDataTableColumnInterface[] = [];
  @Output() openItem: EventEmitter<any> = new EventEmitter();
  @Output() deleteItem: EventEmitter<any> = new EventEmitter();
  @Output() editItem: EventEmitter<any> = new EventEmitter();
  protected listActivePage: any[] = [];
  protected orderBy: { property: string, asc: boolean } = { property: 'id', asc: false };
  protected paging: { activeIndex: number, nbPages: number } =
    { activeIndex: 0, nbPages: 1 };

  ngOnInit() {
    this.orderBy.property = this.defaultOrderProperty;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listData']) {
      this.doOrderBy(this.orderBy.property, true);
    }
  }

  protected doOrderBy(property: string, staySameWay = false): void {
    // if we change property, we always start asc=false
    if (property === this.orderBy.property) {
      if (!staySameWay) {
        this.orderBy.asc = !this.orderBy.asc;
      }
    } else {
      this.orderBy.property = property;
      this.orderBy.asc = false;
    }

    this.listData.sort(this.dynamicSort(property, this.orderBy.asc));

    this.createPagedList(0);
  }

  protected goToPage(pageIndex: number): void {
    if (pageIndex >= 0 && (this.pagingNbItemsPerPage * pageIndex) < this.listData.length) {
      this.createPagedList(pageIndex);
    }
  }

  protected open(listItem: any): void {
    this.openItem.emit(listItem);
  }

  protected edit(listItem: any): void {
    this.editItem.emit(listItem);
  }

  protected delete(listItem: any): void {
    this.deleteItem.emit(listItem);
  }

  private createPagedList(pageIndex = -1): void {
    this.paging.nbPages = Math.ceil(this.listData.length / this.pagingNbItemsPerPage);

    this.paging.activeIndex = (pageIndex !== -1) ? pageIndex : this.paging.activeIndex;
    if (this.paging.activeIndex === this.paging.nbPages) {
      this.paging.activeIndex = this.paging.activeIndex - 1;
    }

    const itemsStartIndex = this.pagingNbItemsPerPage * this.paging.activeIndex;
    this.listActivePage = this.listData.slice(itemsStartIndex, itemsStartIndex + this.pagingNbItemsPerPage);
  }

  private dynamicSort(property: string, asc: boolean) {
    return function(a: any, b: any) {
      // next line works with strings and numbers,
      return (a[property] < b[property]) ? (asc ? 1 : -1) : (a[property] > b[property]) ? (asc ? -1 : 1) : 0;
    };
  }
}
